import React, { Component } from 'react';
import convert from 'xml-js';
import logo from './logo.svg';
import './App.css';
import TBCBackground from './component_tbc/TBCBackground'
import TBCEpisode from './component_tbc/TBCEpisode'
import * as qs from 'query-string';
import ReactLoading from 'react-loading';
import AppBlobCache from './AppBlobCache'
import GlobalStorage from './component_tbc_editor/storage/GlobalStorage'
import Cookies from 'js-cookie'

var CryptoJS = require("crypto-js");
class App extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      is_ready: false,
      is_play: false,
      coverUrl:'',
      coverEpisode:'',
      coverStory:'',
      coverAuthor:''
    }
  }

  componentDidMount()
  {
    this.fetchEpisodeDecrypt();
    // this.fetchEpisode();
  }

  fetchEpisodeDecrypt()
  {
    var key = 'yh123itj83477u0o';
    var iv = 'Rh48fnt9dsh9hU67';
    key = CryptoJS.enc.Utf8.parse(key);
    iv = CryptoJS.enc.Utf8.parse(iv);


    const parsed = qs.parse(global.location.search);
    var url = global.BASE_URL + "/tbc_dummy_test_enc.txt";

    var contentUrl = parsed.contentUrl;
    var mediaListUrl = parsed.mediaListUrl;
    var episodeName = parsed.episodeName;

// getting /story/{storyUUID}/epsiode/{episodeUUID} works
    var storyName = ' '; //needed to update this upon API update
    var authorName = ' '; //needed to update this upon API update
    if (1){ 
    
      let hrefGet = window.location.href.replace(/http:\/\//g, '').replace(/https:\/\//g, '');
      hrefGet = hrefGet.split(/\/*\//);
      hrefGet.splice(0, 1);

      if (hrefGet[0]=='story' && hrefGet[2]=='storyEpisode'){
        
        var storyUUID = hrefGet[1];
        var epsiodeUUID = hrefGet[3];
        
        if (Cookies.get(epsiodeUUID)==undefined){
          
          
          // var API =  (global.API_URL != 'https://api.tbcstory.com/v1/')? global.API_URL.replace("v1","v2") :global.API_URL
          // var API =  global.API_URL;
          var API =  global.API_URL.replace("v1","v2");
          var theUrl = API+"stories/"+storyUUID+"/episode/"+epsiodeUUID;
          var xmlHttp = new XMLHttpRequest();
          xmlHttp.open( "GET", theUrl, false ); // false for synchronous request
          if (Cookies.get('reader_token'))
            xmlHttp.setRequestHeader('Authorization', Cookies.get('reader_token'));


          xmlHttp.send( null );
          if (xmlHttp.status==200){
            var data = JSON.parse(xmlHttp.responseText);
            contentUrl = data.episode.contentUrl;
            mediaListUrl = data.episode.mediaListUrl;
            episodeName = data.episode.title;          
            
            Cookies.set(epsiodeUUID, new Date().getTime(), {expires: inFifeMinutes});                   
            Cookies.set(epsiodeUUID+"-contentUrl", contentUrl, {expires: inFifeMinutes});         
            Cookies.set(epsiodeUUID+"-mediaListUrl", mediaListUrl, {expires: inFifeMinutes});         
            Cookies.set(epsiodeUUID+"-episodeName", episodeName, {expires: inFifeMinutes});                   
          }else{
            var data = JSON.parse(xmlHttp.responseText);
            alert(data.message);
            window.close();
          }
        
        }else{
          contentUrl = Cookies.get(epsiodeUUID+"-contentUrl");
          mediaListUrl = Cookies.get(epsiodeUUID+"-mediaListUrl");
          episodeName = Cookies.get(epsiodeUUID+"-episodeName");
        }        
      }
    }
    

    // if (contentUrl)
    // {
    //   contentUrl = global.DOWNLOAD_API_BASE_URL + `/download/${encodeURIComponent(contentUrl)}`;
    // }
    // if (mediaListUrl)
    // {
    //   mediaListUrl = global.DOWNLOAD_API_BASE_URL + `/download_media/${encodeURIComponent(mediaListUrl)}`;
    // }

    var self = this;
    
    //https://tbc-prod-story-data.s3.ap-southeast-1.amazonaws.com/bc3e4c9f-3df8-42ec-9b15-9d8ba47e57fb/22e3e90b-e73f-4104-8e88-92c3bc219bfb/encryptedXml_1539225210294.xml
    //https://api.tbcstory.com/v1/stories/bc3e4c9f-3df8-42ec-9b15-9d8ba47e57fb/episode/22e3e90b-e73f-4104-8e88-92c3bc219bfb

    if (contentUrl){
      var e = contentUrl;
      var directory = e.split("/").slice(3,-1).join("/")  //split to array & remove last element
      var arr = directory.split("/");
      if (global.DEBUG){
        console.log(arr);
        console.log(global.API_URL+"stories/"+arr[0]+"/episode/"+arr[1]);
      }

      var inFifeMinutes = new Date(new Date().getTime() + 5 * 60 * 1000);
      if (Cookies.get(arr[1])==undefined){
        Cookies.set(arr[1], new Date().getTime(), {
            expires: inFifeMinutes
        });
        fetch(global.API_URL+"stories/"+arr[0]+"/episode/"+arr[1]);
      }

      
    
      new AppBlobCache().preloadMediaListUrl(mediaListUrl)
          .then((response) => {
            return new AppBlobCache().getContentUrl(contentUrl)
          })
          .then((response) => {
            return response.text();
          })
          .then((res) => {

            var decrypted = CryptoJS.AES.decrypt(res, key, {
              iv: iv,
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7
            });

            decrypted = CryptoJS.enc.Utf8.stringify(decrypted);

            if (global.DEBUG)
              console.log(decrypted);

            var json = JSON.parse(convert.xml2json(decrypted, {compact: true, spaces: 4, alwaysArray: ['scene']}));
            if (global.DEBUG){
            console.log('//xml2json//')
            console.log(json)
            }

            self.setState({
              is_ready: true,
              scenes: json.scenes,
              episodeName: episodeName || '',
              storyName: storyName || '',
              authorName: authorName || '',
            })

            if (global.DEBUG)
              console.log("JSON...", json, convert.js2xml(json, {compact: true, spaces: 4,alwaysArray: ['scene']}));
            global.JSONJSON = json;
          })
          .catch((e) => {
            console.error(e);
          })
    }else{
      //is editor - preload GlobalStorage
      var esposide = new GlobalStorage().parseStoryEpisodeItemsToJsonObject()
      if (global.DEBUG){
      console.log('//GlobalStorage esposide//')
      console.log(esposide)
      }

      this.setState({
        is_ready: true,
        scenes: esposide.scenes,
        episodeName: '',
      })

    }
  }

  fetchEpisode()
  {
    var self = this;
    fetch(global.BASE_URL + "/tbc_dummy_test.xml")
        .then((response) => {
          return response.text();
        })
        .then((res) => {
          var json = JSON.parse(convert.xml2json(res, {compact: true, spaces: 4}));
          self.setState({
            is_ready: true,
            scenes: json.scenes,
          })
        })
        .catch((e) => {
          debugger;
        })
  }



  forcePlay(episode)
  {
    this.setState({
      is_ready: true,
      scenes: Object.assign({}, episode).scenes,
    }, () => {
      this.TBCEpisodeViewer && this.TBCEpisodeViewer.resetScenes(this.state.scenes)
    })
  }



  render() {

    const parsed = qs.parse(global.location.search);
    var coverUrl = parsed.coverUrl || this.state.coverUrl;
    var coverEpisode = parsed.episodeName || this.state.episodeName;
    var coverStory = parsed.storyName || this.state.storyName || 'TBC';;
    var coverAuthor = parsed.authorName || this.state.authorName || '故事有本身的傳奇';;    
    return (
        <div className="App MainApp">
          <TBCEpisode {...this.props} scenes={{}} >

            <div {...this.props} style={{position: 'absolute', left: 0, right: 0, bottom: 0, top: 0,
              backgroundColor: '#000',
              backgroundRepeat: `no-repeat`,
              backgroundSize: `contain`,
              backgroundPosition: `50% 50%`,
              backgroundImage: "url("+coverUrl+")"
            }}>
              {this.props.children}
            </div>

            <div {...this.props} style={{position: 'absolute', left: 0, right: 0, bottom: 0, top: 0,
              backgroundColor: 'transparent',
              backgroundRepeat: `repeat`,
              backgroundSize: `stretch`,
              backgroundPosition: `50% 50%`,
              backgroundImage: `url(${global.BASE_URL}/ic_bg_overlay_gray.png)`
            }}>
              {this.props.children}
            </div>

            <div style={{position: `absolute`, backgroundColor: 'transparent', width: `100%`, height: `100%`, display: `flex`, flexDirection: 'column', alignItems: `center`, justifyContent: `center`}}>
              <div style={{textShadow: `0px 2px 4px #000`, fontWeight: 'bold', fontSize: 24, color: '#fff', padding: 15}}>
                {coverEpisode}
              </div>
              <div style={{textShadow: `0px 2px 4px #000`, fontWeight: 'normal', fontSize: 16, color: '#fff', paddingBottom: 20}}>
                {coverStory} - {coverAuthor}
              </div>
              <div style={{margin: `0 auto`, width: 100, height: 100}}>
                {
                  this.state.is_ready ? null : (
                      <div style={{margin: `0 auto`, width: 50, height: 50}}>
                        <ReactLoading type={`balls`} color={`#fff`} height={'100%'} width={'100%'} />
                      </div>
                  )
                }
                {
                  (!this.state.is_play && this.state.is_ready) ? (
                      <a href={'#'}
                         onClick={() => {
                           this.setState({is_play: true})
                         }}>
                        <img style={{width: 100, height: 100}} src={`data:image/png;base64,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`}/>
                      </a>
                  ) : null
                }
              </div>
            </div>
            {
              (this.state.scenes && this.state.is_play && this.state.is_ready) ? (
                  <TBCEpisode
                      ref={(v) => {this.TBCEpisodeViewer = v}}
                      {...this.props} scenes={this.state.scenes} />
              ) : null
            }
          </TBCEpisode>
        </div>
    );
  }
}

export default App;
